import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingView } from './views/LandingView';
import { EdicionesHistoricasView } from './views/EdicionesHistoricasView';
import { AcreditacionView } from './views/AcreditacionView';
import { PadronSorteoView } from './views/PadronSorteoView';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingView />} />
        <Route path="/evento/:idCongreso" element={<LandingView />} />
        <Route path="/ediciones" element={<EdicionesHistoricasView />} />
        <Route path="/acreditacion" element={<AcreditacionView />} />
        <Route path="/sorteo/padron" element={<PadronSorteoView />} />
        <Route path="/evento/:idCongreso/sorteo/padron" element={<PadronSorteoView />} />
        {/* Fallback de redirección */}
        <Route path="*" element={<LandingView />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
